import { speakInsteadOfClip } from "./tx";

/**
 * Talking-head clips (`clipUrl` / `clips`) carry an English soundtrack. When the
 * course text is translated, a device plays the clip muted (the face keeps
 * moving) and speaks the translated line instead, so a translated course never
 * plays English speech. English keeps the filmed voice, and so does a course
 * whose overlay sets `media:clips` = `localized` (its clips are re-voiced).
 */
export { speakInsteadOfClip };

export function playClipSilently(v: HTMLVideoElement | null | undefined, url?: string): void {
  if (!v) return;
  try {
    if (url && v.getAttribute("src") !== url) v.src = url;
    v.muted = true;
    v.currentTime = 0;
    void v.play().catch(() => {});
  } catch {
    /* ignore */
  }
}
